export default "__VITE_ASSET__BCArc7_4__"